import { ConfirmDialog } from "primereact/confirmdialog";
import { useState } from "react";
import avatar from "../../../assets/image/avatar.svg";
import { ROLE } from "../../../Controller/controllerGlobal";
import { Column, Padding, Row } from "../../../Styles/styles";
import { Container } from "./style";
import { useNavigate } from "react-router-dom";
import Icon from "../../Icon";
import styles from "../../../Styles";

const CardRegistration = ({
  title,
  subtitle,
  username,
  idRegistration,
  userId,
  status,
  url_avatar,
  onRemove,
  isLoadingRemove
}: {
  title: string;
  subtitle: string;
  username?: string;
  idRegistration: number;
  status: string;
  userId: number;
  url_avatar?: string;
  onRemove?: () => void;
  isLoadingRemove?: boolean;
}) => {
  const [visible, setVisible] = useState(false);
  const history = useNavigate()


  return (
    <>
      <Container
        className="card cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          history(`${userId}`)
          // if ((propsAplication.user?.role === ROLE.ADMIN ||
          //   propsAplication.user?.role === ROLE.COORDINATORS)) {
          //   history(`/turma/${id}/aluno/${idRegistration}`);
          // }
        }}
      >
        <Row id="end">
          {onRemove && (
            <div
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                if (isLoadingRemove) return;
                setVisible(true);
              }}
            >
              <Icon icon="pi pi-trash" color={styles.colors.grayOne} size="1rem" />
            </div>
          )}
        </Row>
        {/* <Padding padding="8px" /> */}
        <Row>
          <div className={`boxQuantity`}>
            <Column id="center">
              <img
                src={
                  url_avatar ? url_avatar :
                    avatar
                }
                alt=""
                style={{ height: 72, width: 72, borderRadius: "50%" }}
              />
            </Column>
          </div>
          <Padding />
          <Column>
            <h3>{subtitle.substring(0, 24)}{subtitle.length > 24 && "..."}</h3>
            <Padding />
            <div className={"boxDescriptionSchedule"}>
              {"Matricula - " + title}
            </div>
            <Padding />
            {username && (
              <>
                <div className={"boxDescriptionScheduleSubtitle"}>
                  {"Nome de usuário: " + username}
                </div>
                <Padding />
              </>
            )}
            <div className={"boxDescriptionScheduleSubtitle"}>
              {status === ROLE.STUDENT
                ? "Aluno"
                : status === ROLE.TEACHER
                  ? "Professor"
                  : status === ROLE.ADMIN
                    ? "Administrador"
                    : ""}
            </div>
          </Column>
        </Row>
      </Container>
      <ConfirmDialog
        visible={visible}
        onHide={() => setVisible(false)}
        message="Tem certeza de que deseja prosseguir?"
        header="Confirmation"
        icon="pi pi-exclamation-triangle"
        accept={() => {
          onRemove?.();
          setVisible(false);
        }}
        reject={() => setVisible(false)}
      />
    </>
  );
};

export default CardRegistration;
